/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Type guard to detect if an IResolvedUrl is an IRouterliciousResolvedUrl.
 * @internal
 */
export const isRouterliciousResolvedUrl = (resolvedUrl) => resolvedUrl.routerliciousResolvedUrl === true;
//# sourceMappingURL=routerliciousResolvedUrl.js.map